export default __webpack_public_path__ + "static/media/my-farm.75d283a0.svg";